// 9fbef606107a605d69c0edbcd8029e5d
import { loadPageSEOData } from '@tcp/core/src/reduxStore/actions';
import { SEO_DATA } from '@tcp/core/src/reduxStore/constants';

const getSeoData = (pageName, args) => {
  return loadPageSEOData({ page: pageName, ...args })
};

/* eslint-disable import/prefer-default-export */
export const initActions = [
  (args) => {
    const path = `/${args?.apiConfig?.siteId}${SEO_DATA.home}`;
    const loginUrl = `${path}${SEO_DATA.login}`;
    const registerUrl = `${path}${SEO_DATA.register}`;

    if (args?.apiConfig?.asPath === loginUrl) {
      return getSeoData(`${SEO_DATA.home}${SEO_DATA.login}`, args);
    }
    if (args?.apiConfig?.asPath === registerUrl) {
      return getSeoData(`${SEO_DATA.home}${SEO_DATA.register}`, args);
    }
    return getSeoData(SEO_DATA.home, args);
  },
];
